import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  formProperties: {
    fontSize: 12,
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.17,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#000",
  },
  defaultLable: {
    fontSize: "12px !important",
    fontWeight: "normal !important",
    fontStretch: "normal !important",
    fontStyle: "normal !important",
    lineHeight: 1.17,
    letterSpacing: "normal !important",
    textAlign: "left !important",
    color: "#757575",
    marginRight: 0,
  },
  policyInfoLable: {
    fontSize: 12,
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.17,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#757575",
    marginRight: 0,
  },
  defaultStyle: {
    marginRight: 0,
    marginLeft: 0,
    marginBottom: 0,
  },
  skyLable: {
    color: "#757575",
    fontSize: 12,
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.17,
    letterSpacing: "normal",
    textAlign: "left",
  },
  cancelButton: {
    textTransform: "capitalize",
    backgroundColor: "#fff",
    border: "1px solid  #014e8c",
    color: "#014e8c",
    marginRight: "1em",
  },
  submitButton: {
    textTransform: "capitalize",
    backgroundColor: "#014e8c",
    border: "none",
    color: "#fff",
  },
  deactiveButton: {
    textTransform: "capitalize",
    backgroundColor: "red",
    border: "1px solid  #014e8c",
    color: "#fff",
  },
  skyBox: {
    color: "#81d4fa  !important",
    padding: 0,
    paddingRight: 5,
  },
  defaultBox: {
    color: "#757575 !important",
    padding: 0,
    paddingRight: 5,
  },
  editableInput: {
    background: "#fff",
    paddingRight: "2px",
    fontSize: "12px !important",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.33,
    letterSpacing: "normal",
    textAlign: "left",
    paddingLeft:'5px !important',
    borderBottom: "1px solid #81d4fa !important",
   
  },
  error:{
    borderBottom :"1px solid red !important"
  },
  editableInputError:{
    background: "red !important",
  },
  disabledInput: {
    background: "rgba(0, 0, 0, 0.09)",
    paddingLeft: "5px",
    paddingRight: "2px",
    fontSize: "12px !important",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.33,
    letterSpacing: "normal",
    textAlign: "left",
    "&:before": {
      borderBottom: "1px solid #757575",
    },
  },
  defaultSelect: {
    width: "100%",
    textAlign: "left",
    "& div": {
      "&:before": {
        borderBottom: "1px solid #007bff",
      },
    },
  },
  defaultError: {
    width: "100%",
    textAlign: "left",
    "& div": {
      "&:before": {
        borderBottom: "1px solid #FF0000",
      },
    },
  },

  formFields: {
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.17,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#212121",
  },
  menuItem: {
    fontSize: 12,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  autoDropdown: {
    fontSize: "12px !important",
    marginTop: ".4em",
  },
}));
